import axios from 'axios'
const {
  VUE_APP_API_URL,
  VUE_APP_TEST_ERROR,
  VUE_APP_CONS_BIO_API_URL,
  VUE_APP_AMEX,
  VUE_APP_VT_DOCS,
  VUE_APP_SOCKET_API,
  VUE_APP_VT_API_URL,
} = process.env

const getBooking = async (
  username,
  bookingNumber,
  source,
  validateemail = false,
  token = '',
) => {
  try {
    // will normally be ext, only internal consultants will change it to int
    let sourceParam = 'EXT'
    if (source) sourceParam = source.toUpperCase()
    let systemSite = 'UK'
    if (bookingNumber.charAt(0) === 'R') {
      systemSite = 'IE'
    }
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/booking`,
      {
        bookingName: username,
        bookingNumber: bookingNumber,
        source: sourceParam,
        system: systemSite,
        validateemail: validateemail,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const getItineraryImages = async (data) => {
  try {
    return await axios.post(`${VUE_APP_API_URL}/api/hosted/viewtrail`, data)
  } catch (err) {
    return null
  }
}

const getConsBioImage = async (_logname) => {
  try {
    return await axios.get(
      `${VUE_APP_CONS_BIO_API_URL}/consultant/picture/${_logname}`,
    )
  } catch (err) {
    return null
  }
}

const getCovidDataReferer = async (_referer) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_API_URL}/api/covid-country-info/${_referer}`
    const res = await axios.get(url)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const getCovidDataCityCodes = async (_data) => {
  try {
    const url =
      VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/info_records_by_citycode`
    const res = await axios.post(url, _data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const getCovidDataSupplierCodes = async (data) => {
  const result = { error: false }
  try {
    const url = `${VUE_APP_API_URL}/api/info_records_by_suppliercode`
    const res = await axios.post(url, data)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const markNotificationsRead = async (bookingNumber) => {
  const result = { error: false }
  try {
    const url =
      VUE_APP_TEST_ERROR ||
      `${VUE_APP_API_URL}/api/viewtrail/op-client-emails-read/${bookingNumber}`

    const res = await axios.get(url)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const preloadVoucher = async (bookingNumber, voucherId) => {
  try {
    const url =
      VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/superfacts/voucher/show`
    const payload = {
      BOOKNO: bookingNumber,
      VOUCHNO: voucherId,
    }
    const res = await axios.post(url, payload)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const amexUpdate = async (payload) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_AMEX}/callback`

    const res = await axios.post(url, payload)
    if (res && res.data) {
      result.data = res.data
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}

const checkForCruiseLineInvoice = async (data) => {
  try {
    // const res = await axios.get(`${VUE_APP_API_URL}/tourdoc/cruise/${bookingNumber}.pdf`)
    const res = await axios.post(`${VUE_APP_VT_DOCS}/get-cruise-invoice`, data)
    return res
  } catch (err) {
    return null
  }
}

const createPaymentLog = async (data) => {
  const result = axios.post(`${VUE_APP_SOCKET_API}/so-api/v1/pay/1/log`, data)
  return result
}

const getTrustPilotURL = async (bookingNumber, passenger) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/trustPilotFeedback`,
      {
        bookingNumber,
        passenger,
      },
    )
    if (res && res.data) {
      return res.data
    }
  } catch (error) {
    return error
  }
}

const getOTPUnmaskedPassengerData = async (token, bookingNumber, passenger) => {
  try {
    const res = await axios.post(
      `${VUE_APP_VT_API_URL}/vt-api/viewtrail/otp/verifyClientData`,
      {
        bookingNumber,
        passenger,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
    if (res && res.data) {
      return res
    }
  } catch (error) {
    return error
  }
}

export {
  getBooking,
  getItineraryImages,
  markNotificationsRead,
  preloadVoucher,
  getConsBioImage,
  getCovidDataCityCodes,
  getCovidDataSupplierCodes,
  getCovidDataReferer,
  amexUpdate,
  checkForCruiseLineInvoice,
  createPaymentLog,
  getTrustPilotURL,
  getOTPUnmaskedPassengerData,
}
